import { useRef, useEffect, HTMLAttributes, useState, FC } from 'react';
import classNames from 'classnames';
import './texthint.scss';
import { Hint } from '@redoc/ui-kit';

interface TextHintProps extends HTMLAttributes<HTMLDivElement> {
	children: string;
	align?: 'left' | 'center' | 'right';
	isList?: boolean;
	disable?: boolean;
}

/** Компонента для отображения текста, при переполнении текст обрезается и показывается подсказка  */
const TextHint: FC<TextHintProps> = (props) => {
	const {
		disable = false,
		isList = false,
		align = 'left',
		children,
		style,
		className,
		...otherProps
	} = props;

	const spanRef = useRef<HTMLDivElement>(null);
	const [isOverflow, setIsOverflow] = useState(false);

	useEffect(() => {
		if (disable || !spanRef.current) {
			return;
		}

		const current = spanRef.current;

		setIsOverflow(
			current.scrollWidth > current.clientWidth ||
				current.scrollHeight > current.clientHeight,
		);
	}, [children, disable, isList]);

	const hintText = isList ? children.replaceAll(',', '</br>') : children;

	const content = (
		<div
			ref={spanRef}
			className={classNames('rdc_texthint', className)}
			style={{ textAlign: align, ...style }}
			{...otherProps}
		>
			{children}
		</div>
	);

	if (!isOverflow) {
		return content;
	}

	return (
		<Hint messageText={hintText} placement="top">
			{content}
		</Hint>
	);
};

export default TextHint;
